import { message } from "antd";
import i18next from "i18next";
import { call, put, takeLatest } from "redux-saga/effects";
import { addUserApi, deleteUserApi, editUserApi, getUsersApi } from "../../../services/api/users";
import { addUser, deleteUser, editUser, setLoading, setUsers } from "../../actions/users";

function* getUsersAsync() {
  try {
    yield put(setLoading(true));
    const response = yield call(getUsersApi);
    const { data } = response;
    if (data) {
      yield put(setUsers(data));
      message.success(i18next.t("admin.users.server.success"));
    } else {
      message.error("Erreur : " + response.statusText, {
        position: "bottom-right",
        autoClose: 2000,
      });
      window.location.replace("/home-sso");
    }
  } catch (e) {
    console.error(e);
  }

  yield put(setLoading(false));
}

function* addUserAsync({ data: { body, redirection } }) {
  try {
    yield put(setLoading(true));
    const { data } = yield call(addUserApi, body);
    if (data) {
      yield put(addUser(data));
      message.success(i18next.t("admin.users.add.server.success"));
      if (redirection) {
        redirection();
      }
    } else {
      message.error(i18next.t("admin.users.add.server.error"));
    }
  } catch (e) {
    console.error(e);
  }

  yield put(setLoading(false));
}

function* deleteUserAsync({ data: { id } }) {
  try {
    yield put(setLoading(true));
    const { response } = yield call(deleteUserApi, id);
    if (response.ok) {
      yield put(deleteUser(id));

      message.success(i18next.t("admin.users.server.delete.success"));
    } else {
      message.error(i18next.t("admin.users.edit.server.error"));
    }
  } catch (e) {
    console.error(e);
  }

  yield put(setLoading(false));
}

function* editUserAsync({ data: { id, body, redirection } }) {
  try {
    yield put(setLoading(true));
    const { data } = yield call(editUserApi, id, body);
    if (data) {
      yield put(editUser(data));
      message.success(i18next.t("admin.users.edit.server.success"));
      if (redirection) {
        redirection();
      }
    } else {
      message.error(i18next.t("admin.users.edit.server.error"));
    }
  } catch (e) {
    console.error(e);
  }

  yield put(setLoading(false));
}

export function* usersSaga() {
  yield takeLatest("GET_USERS_REQUEST", getUsersAsync);
}

export function* addUserSaga() {
  yield takeLatest("ADD_USER_REQUEST", addUserAsync);
}

export function* deleteUserSaga() {
  yield takeLatest("DELETE_USER_REQUEST", deleteUserAsync);
}

export function* editUserSaga() {
  yield takeLatest("EDIT_USER_REQUEST", editUserAsync);
}
